// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__y5Yba","validationTips":"StatementDescriptor_validationTips__ur4MV"};